import { render } from "./PDFGenerator.vue?vue&type=template&id=150b84e1"
import script from "./PDFGenerator.vue?vue&type=script&lang=js"
export * from "./PDFGenerator.vue?vue&type=script&lang=js"

import "./PDFGenerator.vue?vue&type=style&index=0&id=150b84e1&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\studievalg-digital-tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__